// SubscriptionContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { auth, db } from "../firebase/firebaseConfig";
import { doc, onSnapshot } from "firebase/firestore";

const SubscriptionContext = createContext();

export const useSubscription = () => {
    const context = useContext(SubscriptionContext);
    if (!context) {
        throw new Error('useSubscription must be used within a SubscriptionProvider');
    }
    return context;
};

export const SubscriptionProvider = ({ children }) => {
    const [subscription, setSubscription] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribeAuth = auth.onAuthStateChanged((user) => {
            if (user) {
                // Listen to real-time subscription updates
                const userDocRef = doc(db, "users", user.uid);
                const unsubscribeFirestore = onSnapshot(userDocRef, (docSnap) => {
                    if (docSnap.exists()) {
                        const userData = docSnap.data();
                        setSubscription(userData.subscription || null);
                    } else {
                        setSubscription(null);
                    }
                    setLoading(false);
                });

                return unsubscribeFirestore;
            } else {
                setSubscription(null);
                setLoading(false);
            }
        });

        return unsubscribeAuth;
    }, []);

    const isSubscriptionActive = () => {
        if (!subscription) return false;
        const now = new Date();
        const expiryDate = subscription.expiryDate.toDate();
        return expiryDate > now;
    };

    const value = {
        subscription,
        isSubscriptionActive: isSubscriptionActive(),
        loading
    };

    return (
        <SubscriptionContext.Provider value={value}>
            {children}
        </SubscriptionContext.Provider>
    );
};

